"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _browser = require("../../browser");
var _assets = require("../../assets");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var WarningContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: 550px;\n  padding: 2em 0;\n  display: block;\n  margin: 0 auto;\n"])));
var WarningTitleContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 2em;\n  margin-bottom: 10px;\n  display: inline-flex;\n"])));
var WarningTitle = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  vertical-align: middle;\n  line-height: initial;\n"])));
var WarningText = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 1em;\n"])));
var Warning = function Warning(props) {
  var onContinue = props.onContinue,
    onBack = props.onBack,
    warning = props.warning;
  var warningKey = Object.keys(warning).find(function (key) {
    return warning[key];
  });
  return _react["default"].createElement(_browser.Container, null, _react["default"].createElement(WarningContainer, null, _react["default"].createElement(WarningTitleContainer, null, _react["default"].createElement("div", null, _react["default"].createElement(_assets.WarningIcon, null)), _react["default"].createElement(WarningTitle, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.warning.title"
  }))), _react["default"].createElement(WarningText, null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.warning.".concat(warningKey)
  }))), _react["default"].createElement(_browser.Button, {
    type: "button",
    color: "navigationBack",
    size: "large",
    onClick: function onClick() {
      return onBack();
    }
  }, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.button.back"
  })), _react["default"].createElement(_browser.Button, {
    type: "button",
    color: "green",
    size: "large",
    onClick: function onClick() {
      return onContinue();
    }
  }, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.button.continue"
  })));
};
var _default = exports["default"] = Warning;